import { Dispatch } from 'redux';
import { PickedAnswerRequest } from '../../../models/requests/pickedAnswer.request';
import {
  PICKED_ANSWER_RESET,
  PICKED_ANSWER_START,
  PICKED_ANSWER_SUCCESS
} from './constants';
import { pickedAnswerRequest } from './repository';
import {
  PickedAnswerResetAction,
  PickedAnswerStartAction,
  PickedAnswerSuccessAction
} from './types';

const pickedAnswerStartAction = (): PickedAnswerStartAction => {
  return {
    type: PICKED_ANSWER_START,
  };
};
const pickedAnswerSuccessAction = (payload: boolean): PickedAnswerSuccessAction => {
  return {
    type: PICKED_ANSWER_SUCCESS,
    payload: payload,
  };
};
const pickedAnswerResetAction = (): PickedAnswerResetAction => {
  return {
    type: PICKED_ANSWER_RESET,
  };
};

export const pickedAnswer = (request: PickedAnswerRequest) => async (dispatch: Dispatch) => {
  try {
    dispatch(pickedAnswerStartAction());
    await pickedAnswerRequest(request);
    dispatch(pickedAnswerSuccessAction(true));
  } catch (error) {
  }
};

export const pickedAnswerReset = () => (dispatch: Dispatch) => {
  dispatch(pickedAnswerResetAction());
};
